import React from 'react';
import * as MUI from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { useStyles } from './styles';
import InformationIcon from '../../../../../icons/Information';

export const Information: React.FC<{loading?: boolean, description?: string[]}> = ({description, loading}) => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (loading) {
    return <Skeleton variant="circle" width={48} height={48} />
  }
  if (!description || description.length === 0) {
    return null;
  }
  return (<>
    <MUI.IconButton className={classes.button} aria-label="Information" onClick={handleClick}>
      <InformationIcon />
    </MUI.IconButton>
    <MUI.Popover
      id='report-description'
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <MUI.Paper className={classes.paper}>
        <ul>
          {description?.map(line => (<li key={line}>{line}</li>))}
        </ul>
      </MUI.Paper>
    </MUI.Popover>
  </>);
} 